// Bildirim (zil) API Servisi
const API_BASE_URL = process.env.REACT_APP_API_URL || "https://iyiliginmucitleri.com/api";

const authHeader = () => ({ Authorization: `Bearer ${localStorage.getItem("token")}` });

const notificationService = {
  // Son bildirimler + okunmamış sayısı
  getNotifications: async () => {
    const response = await fetch(`${API_BASE_URL}/notifications`, { headers: authHeader() });
    if (!response.ok) throw new Error("Bildirimler getirilemedi");
    return await response.json();
  },

  markRead: async (notificationId) => {
    const response = await fetch(`${API_BASE_URL}/notifications/${notificationId}/read`, {
      method: "PUT",
      headers: authHeader()
    });
    if (!response.ok) throw new Error("Bildirim güncellenemedi");
    return await response.json();
  },

  markAllRead: async () => {
    const response = await fetch(`${API_BASE_URL}/notifications/read-all`, {
      method: "PUT",
      headers: authHeader()
    });
    if (!response.ok) throw new Error("Bildirimler güncellenemedi");
    return await response.json();
  }
};

export default notificationService;
